module.exports = global["$"] = require("-!C:\\Users\\User\\projects\\mazay\\node_modules\\expose-loader\\index.js?jQuery!C:\\Users\\User\\projects\\mazay\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 2
// module chunks = 0